import { gql, useLazyQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import {
  GetRegisterAssignmentsByPermitRegisterId,
  GetRegisterAssignmentsByPermitRegisterIdVariables,
} from "./__generated__/GetRegisterAssignmentsByPermitRegisterId";
import { ORG_USER_FIELDS } from "../fragments/OrgUser";
import { CORE_PERMIT_REGISTER_FIELDS } from "../fragments/PermitRegister";

export const GET_REGISTER_ASSIGNMENTS_BY_PERMIT_REGISTER_ID = gql`
  ${ORG_USER_FIELDS}
  ${CORE_PERMIT_REGISTER_FIELDS}
  query GetRegisterAssignmentsByPermitRegisterId($permitRegisterId: String!) {
    registerAssignmentsByPermitRegisterId(permitRegisterId: $permitRegisterId) {
      id
      permitRegister {
        ...CorePermitRegisterFields
        project {
          id
          name
        }
      }
      permitTypeOrgRole {
        id
        orgRole {
          id
          roleId
          displayName
          licenceType
        }
        permitType {
          id
          name
        }
      }
      orgUser {
        ...OrgUserFields
        licenceId
        licence {
          id
          productName
          type
        }
      }
      isDisabled
    }
  }
`;

export function useGetRegisterAssignmentsByPermitRegisterId() {
  const [getRegisterAssignmentsByPermitRegisterId, { loading, error, data }] = useLazyQuery<
    GetRegisterAssignmentsByPermitRegisterId,
    GetRegisterAssignmentsByPermitRegisterIdVariables
  >(GET_REGISTER_ASSIGNMENTS_BY_PERMIT_REGISTER_ID, {
    errorPolicy: "all",
  });

  return {
    getRegisterAssignmentsByPermitRegisterId,
    data,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncQueryStatus,
  };
}
